<h4 class="point__section-title">
  <ng-content select="[heading]"></ng-content>

  <div class="point__section-title--right">
    <ng-content select="[secondary]"></ng-content>
  </div>
</h4>
